import { DropdownOption } from "core/models";

const aspectRatioOptions: DropdownOption[] = [
    {
        id: 1,
        title: "16:9",
        iconName: "landscape",
        value: "16:9",
        description: "Landscape",
    },
    {
        id: 2,
        title: "9:16",
        iconName: "portrait",
        value: "9:16",
        description: "Instagram stories",
    },
    {
        id: 3,
        title: "4:5",
        iconName: "square-portrait",
        value: "4:5",
        description: "Portrait",
    },
    {
        id: 4,
        title: "2:3",
        iconName: "square-portrait",
        value: "2:3",
    },
    {
        id: 5,
        title: "2:1",
        iconName: "square-landscape",
        value: "2:1",
    },
    {
        id: 6,
        title: "1:2",
        iconName: "square-landscape",
        value: "1:2",
    },
    {
        id: 7,
        title: "1:1",
        iconName: "square",
        value: "1:1",
        description: "Square",
    },
];
export default aspectRatioOptions;
